import React, { useContext } from "react";
import { Dialog, DialogContent } from "@mui/material";
import { CloseOutlined } from "@ant-design/icons";
import "../css/CommercialUserProfileDialog.css";
import { ACCOUNT_ROLE_STATUS } from "../../utils/constants";
import { useFormData } from "../../helpers/FormDataProvider";
import { StorageContext } from "../../services/StorageProvider";

const CommercialUserProfileDialog = ({ open, onClose }) => {
  const { userData } = useFormData();
  const { userProfileData } = useContext(StorageContext);

  return (
    <Dialog
      open={open ?? false}
      onClose={onClose}
      PaperProps={{
        className: "commercial-user-profile-dialog-container",
      }}
    >
      <DialogContent>
        <CloseOutlined
          className="commercial-user-profile-dialog-close"
          onClick={onClose}
        />
        <div className="commercial-user-profile-dialog-content">
          <div className="commercial-user-profile-dialog-title">Profile</div>
          <div className="commercial-user-profile-input-container">
            <label>Name</label>
            <div className="commercial-user-profile-non-editable-field">
              {userData.isAAUser
                ?  `${userProfileData?.data?.firstName} ${userProfileData?.data?.lastName}`
                :`${userProfileData?.firstName} ${userProfileData?.lastName}`}
            </div>
          </div>
          <div className="commercial-user-profile-input-container">
            <label>Email</label>
            <div className="commercial-user-profile-non-editable-field">
              {userData.isAAUser
                ? userProfileData?.data?.email
                : userProfileData?.email}
            </div>
          </div>
          <div className="commercial-user-profile-input-container">
            <label>User Account</label>
            <div className="commercial-user-profile-non-editable-field">
              {userData.isAAUser
                ? "Airport Authority"
                : ACCOUNT_ROLE_STATUS.find(
                    (type) => type.value === userProfileData?.role
                  )?.name}
            </div>
          </div>
          {!userData.isAAUser && userProfileData?.airlineAssociations && (
            <>
              <div className="commercial-user-profile-input-container">
                <label>Airline Access</label>
                <div className="commercial-user-profile-non-editable-field">
                  {userProfileData?.airlineAssociations
                    ?.map((association) => association.airlineName)
                    .filter(Boolean)
                    .join(", ")}
                </div>
              </div>
            </>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default CommercialUserProfileDialog;
